const letter3DictionaryArray = [
    "Ace",
    "Aid",
    "Aim",
    "Air",
    "Ale",
    "Arm",
    "Art",
    "Awl",
    "Eel",
    "Ear",
    "Era",
    "Ice",
    "Ire",
    "Ilk",
    "Oar",
    "Oak",
    "Oat",
    "Oil",
    "Ore",
    "Owl",
    "Urn",
    "Web",
    "Cab",
    "Dab",
    "Jab",
    "Lab",
    "Tab",
    "Dad",
    "Fad",
    "Lad",
    "Mad",
    "Bag",
    "Gag",
    "Hag",
    "Lag",
    "Mag",
    "Rag",
    "Tag",
    "Pal",
    "Cam",
    "Dam",
    "Fam",
    "Ham",
    "Jam",
    "Ram",
    "Ban",
    "Can",
    "Fan",
    "Man",
    "Pan",
    "Tan",
    "Bap",
    "Cap",
    "Lap",
    "Pap",
    "Rap",
    "Sap",
    "Tap",
    "Yap",
    "Bar",
    "Car",
    "Jar",
    "Tar",
    "War",
    "Bat",
    "Cat",
    "Hat",
    "Mat",
    "Pat",
    "Tat",
    "Rat",
    "Vat",
    "Caw",
    "Jaw",
    "Law",
    "Maw",
    "Paw",
    "Bay",
    "Cay",
    "Day",
    "Hay",
    "Ray",
    "Pay",
    "Way",
    "Max",
    "Sax",
    "Tax",
    "Pea",
    "Sea",
    "Tea",
    "Bed",
    "Med",
    "Leg",
    "Peg",
    "Bee",
    "Lee",
    "Tee",
    "Gem",
    "Bet",
    "Jet",
    "Net",
    "Pet",
    "Set",
    "Den",
    "Hen",
    "Men",
    "Pen",
    "Ten",
    "Yen",
    "Dew",
    "Mew",
    "Pew",
    "Bib",
    "Fib",
    "Jib",
    "Rib",
    "Sib",
    "Bid",
    "Kid",
    "Lid",
    "Vid",
    "Tie",
    "Lie",
    "Pie",
    "Fig",
    "Jig",
    "Pig",
    "Rig",
    "Wig",
    "Dim",
    "Bin",
    "Din",
    "Fin",
    "Gin",
    "Pin",
    "Sin",
    "Tin",
    "Win",
    "Yin",
    "Dip",
    "Lip",
    "Pip",
    "Sip",
    "Tip",
    "Git",
    "Hit",
    "Kit",
    "Pit",
    "Wit",
    "Bod",
    "Cod",
    "God",
    "Mod",
    "Pod",
    "Rod",
    "Doe",
    "Foe",
    "Hoe",
    "Roe",
    "Toe",
    "Bog",
    "Cog",
    "Dog",
    "Fog",
    "Hog",
    "Jog",
    "Log",
    "Poi",
    "Con",
    "Son",
    "Ton",
    "Zoo",
    "Cop",
    "Hop",
    "Mop",
    "Pop",
    "Top",
    "Bot",
    "Cot",
    "Dot",
    "Lot",
    "Pot",
    "Tot",
    "Bow",
    "Cow",
    "Sow",
    "Row",
    "Box",
    "Lox",
    "Pox",
    "Boy",
    "Soy",
    "Toy",
    "Cub",
    "Nub",
    "Pub",
    "Sub",
    "Tub",
    "Bug",
    "Hug",
    "Jug",
    "Mug",
    "Rug",
    "Tug",
    "Bum",
    "Gum",
    "Hum",
    "Rum",
    "Tum",
    "Bun",
    "Gun",
    "Pun",
    "Run",
    "Sun",
    "Cup",
    "Pup",
    "Cut",
    "Gut",
    "Hut",
    "Nut",
    "Rut",
    "Egg",
    "Ego",
    "Elf",
    "Elm",
    "Emu",
    "End",
    "Era",
    "Eve",
    "Eye",
    "Ink",
    "Inn",
    "Ion",
    "Ivy",
    "Lye",
    "Dye",
    "Rye",
    "Pus",
    "Gym",
    "Her",
    "His",
    "Him",
    "Our",
    "You",
    "She",
    "Add",
    "Are",
    "Eat",
    "Oil",
    "Use",
    "Nab",
    "Jab",
    "Bag",
    "Lag",
    "Nag",
    "Rag",
    "Sag",
    "Tag",
    "Wag",
    "Jam",
    "Ram",
    "Tan",
    "Cap",
    "Lap",
    "Nap",
    "Rap",
    "Sap",
    "Tap",
    "Yap",
    "Mar",
    "Has",
    "Was",
    "Pat",
    "Lay",
    "Pay",
    "Say",
    "Tax",
    "See",
    "Get",
    "Let",
    "Net",
    "Met",
    "Pet",
    "Set",
    "Wet",
    "Mew",
    "Sew",
    "Lie",
    "Tie",
    "Bog",
    "Jog",
    "Boo",
    "Coo",
    "Moo",
    "Bop",
    "Hop",
    "Lop",
    "Mop",
    "Pop",
    "Top",
    "Sop",
    "Bow",
    "Mow",
    "Row",
    "Tow",
    "Dub",
    "Rub",
    "Lug",
    "Tug",
    "Hum",
    "Sup",
    "Buy",
    "Jot",
    "Rot",
    "Nod",
    "Hem",
    "Wed",
    "Fib",
    "Jib",
    "Rib",
    "Did",
    "Dig",
    "Jig",
    "Rig",
    "Dip",
    "Nip",
    "Sip",
    "Rip",
    "Zip",
    "Gin",
    "Win",
    "Bit",
    "Hit",
    "Sit",
    "Pry",
    "Try",
    "Cry",
    "All",
    "Fab",
    "Bad",
    "Mad",
    "Far",
    "Fat",
    "Raw",
    "Lax",
    "Gay",
    "Big",
    "Dim",
    "Fit",
    "Red",
    "Wet",
    "Old",
    "New",
    "Hot",
    "Coy",
    "Fun",
    "Ill",
    "Odd",
    "Shy",
    "Dry",
    "And",
    "But",
    "Yet",
    "For",
    "Nor",
    "The",
    "Not",
    "How",
    "Too",
    "Yet",
    "Now",
    "Off",
    "Any",
    "Out",
    "Bam",
    "Nah",
    "Yea",
    "Yep",
    "Naw",
    "Hey",
    "Yay",
    "Nay",
    "Pow",
    "Wow",
    "Moo",
    "Boo",
    "Bye",
    "Yum",
    "Ugh",
    "Bah",
    "Umm",
    "Why",
    "Aha",
    "Aye",
    "Hmm",
    "Hah",
    "Huh",
    "Ssh",
    "Brr",
    "Heh",
    "Oop",
    "Oof",
    "Zzz",
    "Gee",
    "Grr",
    "Yup",
    "Gah",
    "Mmm",
    "Arr",
    "Eww",
    "Ehh",
    "ace",
    "act",
    "add",
    "age",
    "aid",
    "aim",
    "air",
    "all",
    "and",
    "any",
    "ape",
    "arm",
    "art",
    "ash",
    "ask",
    "ate",
    "awe",
    "era",
    "ova",
    "pia",
    "spa",
    "ban",
    "bar",
    "bat",
    "cab",
    "can",
    "cap",
    "car",
    "cat",
    "fan",
    "lag",
    "mad",
    "nag",
    "pan",
    "par",
    "pat",
    "rag",
    "ram",
    "ran",
    "rat",
    "sac",
    "sap",
    "sat",
    "van",
    "yam",
    "bad",
    "bag",
    "ban",
    "bar",
    "bat",
    "bay",
    "bed",
    "bee",
    "beg",
    "bet",
    "bid",
    "big",
    "bin",
    "bit",
    "box",
    "boy",
    "bra",
    "bun",
    "bus",
    "but",
    "buy",
    "dab",
    "dub",
    "hub",
    "jab",
    "lob",
    "mob",
    "orb",
    "pub",
    "rub",
    "sub",
    "tub",
    "cab",
    "can",
    "cap",
    "car",
    "cat",
    "cow",
    "cry",
    "cub",
    "cup",
    "cut",
    "cab",
    "can",
    "cow",
    "cry",
    "cob",
    "cod",
    "cog",
    "col",
    "con",
    "cot",
    "cox",
    "coy",
    "arc",
    "bic",
    "chic",
    "hic",
    "mic",
    "pic",
    "sic",
    "tic",
    "ace",
    "act",
    "ice",
    "dad",
    "dag",
    "dam",
    "deb",
    "den",
    "dig",
    "dim",
    "din",
    "doc",
    "dog",
    "don",
    "dry",
    "dub",
    "dud",
    "due",
    "dug",
    "duo",
    "dye",
    "bad",
    "bud",
    "did",
    "fed",
    "god",
    "mad",
    "mud",
    "red",
    "sad",
    "wed",
    "add",
    "edd",
    "odd",
    "ear",
    "eat",
    "ebb",
    "edh",
    "eek",
    "eel",
    "egg",
    "ego",
    "eke",
    "elf",
    "ell",
    "elm",
    "emf",
    "emu",
    "end",
    "eng",
    "ens",
    "eon",
    "era",
    "age",
    "awe",
    "bye",
    "dye",
    "fie",
    "hue",
    "lie",
    "pye",
    "ski",
    "tie",
    "cee",
    "dee",
    "fee",
    "gee",
    "keg",
    "lee",
    "mee",
    "peg",
    "see",
    "tee",
    "fan",
    "far",
    "fat",
    "fax",
    "fay",
    "fed",
    "fee",
    "fem",
    "fey",
    "fig",
    "fin",
    "fir",
    "fit",
    "fix",
    "fly",
    "fog",
    "fop",
    "for",
    "fox",
    "fry",
    "fun",
    "fur",
    "bar",
    "caf",
    "daf",
    "oaf",
    "gap",
    "gar",
    "gas",
    "gay",
    "gel",
    "gem",
    "get",
    "gig",
    "gin",
    "git",
    "gob",
    "god",
    "got",
    "gum",
    "guy",
    "gym",
    "dig",
    "fog",
    "jog",
    "leg",
    "lug",
    "mug",
    "rag",
    "had",
    "ham",
    "hap",
    "has",
    "hat",
    "hay",
    "hem",
    "hen",
    "her",
    "him",
    "hip",
    "hit",
    "hog",
    "hop",
    "hot",
    "how",
    "hub",
    "hug",
    "hum",
    "ash",
    "bah",
    "doh",
    "heh",
    "noh",
    "ohh",
    "rah",
    "shh",
    "huh",
    "ice",
    "icy",
    "ill",
    "imp",
    "ink",
    "inn",
    "ins",
    "into",
    "ion",
    "its",
    "ivy",
    "iron",
    "ami",
    "avi",
    "bib",
    "bit",
    "bin",
    "bis",
    "his",
    "hit",
    "kit",
    "lib",
    "lip",
    "lit",
    "mid",
    "mix",
    "pig",
    "pin",
    "pit",
    "rib",
    "rid",
    "rig",
    "rip",
    "sit",
    "six",
    "tin",
    "tip",
    "jab",
    "jag",
    "jam",
    "jar",
    "jaw",
    "jet",
    "jew",
    "job",
    "joe",
    "jog",
    "joy",
    "jug",
    "jut",
    "hij",
    "haj",
    "ouj",
    "kab",
    "kaf",
    "kai",
    "kat",
    "kay",
    "keg",
    "ken",
    "key",
    "kid",
    "kin",
    "kit",
    "koi",
    "kop",
    "kor",
    "kos",
    "kue",
    "kye",
    "ask",
    "elk",
    "ink",
    "lab",
    "lag",
    "lam",
    "lap",
    "lar",
    "las",
    "lat",
    "law",
    "led",
    "leg",
    "lei",
    "let",
    "lid",
    "lie",
    "lin",
    "lip",
    "lit",
    "lob",
    "log",
    "lop",
    "lot",
    "low",
    "lug",
    "lux",
    "all",
    "ill",
    "pul",
    "sol",
    "dal",
    "gal",
    "tel",
    "til",
    "cal",
    "col",
    "dol",
    "fel",
    "fil",
    "gel",
    "oil",
    "pal",
    "pol",
    "sal",
    "mol",
    "vel",
    "alp",
    "elk",
    "ilk",
    "ale",
    "ell",
    "elf",
    "mad",
    "man",
    "map",
    "may",
    "men",
    "met",
    "mid",
    "mil",
    "mix",
    "mom",
    "mon",
    "mop",
    "mud",
    "mug",
    "mus",
    "mut",
    "max",
    "meg",
    "mil",
    "mir",
    "mob",
    "mod",
    "moa",
    "mog",
    "mow",
    "mum",
    "aim",
    "arm",
    "gem",
    "gym",
    "him",
    "rum",
    "yam",
    "gum",
    "pom",
    "pum",
    "tam",
    "dam",
    "cam",
    "ham",
    "ram",
    "sam",
    "tom",
    "lam",
    "bum",
    "nap",
    "nag",
    "nip",
    "nut",
    "net",
    "nit",
    "not",
    "nor",
    "new",
    "nun",
    "nab",
    "nod",
    "nay",
    "nub",
    "nim",
    "nil",
    "nay",
    "bin",
    "tin",
    "pin",
    "win",
    "run",
    "fun",
    "bun",
    "son",
    "pan",
    "pen",
    "sun",
    "con",
    "nun",
    "ban",
    "van",
    "ton",
    "hen",
    "yon",
    "oaf",
    "oak",
    "oar",
    "oat",
    "obe",
    "off",
    "oil",
    "old",
    "ole",
    "one",
    "ooh",
    "ops",
    "opt",
    "orb",
    "ort",
    "our",
    "out",
    "owe",
    "owl",
    "own",
    "ado",
    "bio",
    "ego",
    "hoo",
    "mho",
    "oho",
    "pro",
    "tao",
    "woe",
    "boo",
    "coo",
    "goo",
    "hoo",
    "too",
    "voo",
    "zoo",
    "pad",
    "pal",
    "pan",
    "pat",
    "paw",
    "pay",
    "pea",
    "peg",
    "pen",
    "per",
    "pet",
    "pew",
    "phi",
    "pic",
    "pie",
    "pig",
    "pin",
    "pit",
    "poi",
    "pol",
    "pom",
    "pop",
    "pow",
    "yep",
    "yup",
    "wap",
    "wop",
    "cup",
    "gap",
    "hop",
    "lap",
    "map",
    "nip",
    "pop",
    "rap",
    "tip",
    "Qat",
    "Qua",
    "Que",
    "red",
    "rib",
    "rob",
    "rug",
    "rum",
    "bur",
    "cur",
    "fur",
    "pur",
    "sir",
    "sur",
    "ark",
    "arm",
    "art",
    "sag",
    "sat",
    "sea",
    "see",
    "sen",
    "set",
    "sew",
    "sex",
    "she",
    "shy",
    "sip",
    "sir",
    "six",
    "ski",
    "sky",
    "sob",
    "son",
    "sop",
    "gas",
    "his",
    "bus",
    "was",
    "yes",
    "ism",
    "ess",
    "asp",
    "toy",
    "tie",
    "tax",
    "tag",
    "top",
    "try",
    "tea",
    "ton",
    "tab",
    "too",
    "tip",
    "tin",
    "the",
    "tug",
    "tum",
    "ten",
    "toe",
    "tan",
    "cat",
    "hat",
    "mat",
    "rat",
    "sat",
    "cut",
    "but",
    "gut",
    "hot",
    "not",
    "put",
    "wet",
    "bit",
    "lit",
    "sit",
    "nut",
    "rut",
    "ups",
    "use",
    "uns",
    "ugh",
    "urb",
    "urn",
    "uts",
    "ugh",
    "ulu",
    "ump",
    "ufo",
    "upo",
    "feu",
    "flu",
    "gru",
    "jeu",
    "leu",
    "rue",
    "tau",
    "vau",
    "piu",
    "cru",
    "fug",
    "gum",
    "gut",
    "mud",
    "mug",
    "mum",
    "nut",
    "rug",
    "sub",
    "sum",
    "bud",
    "bun",
    "but",
    "cur",
    "cut",
    "fun",
    "gun",
    "hut",
    "van",
    "vat",
    "via",
    "vet",
    "vox",
    "vow",
    "vis",
    "vug",
    "dev",
    "lav",
    "rev",
    "lev",
    "wag",
    "was",
    "way",
    "web",
    "wed",
    "wet",
    "who",
    "why",
    "win",
    "wiz",
    "wry",
    "wud",
    "bow",
    "how",
    "now",
    "row",
    "sow",
    "yaw",
    "low",
    "mow",
    "tow",
    "wow",
    "xis",
    "xyl",
    "box",
    "lax",
    "hex",
    "wax",
    "tax",
    "vex",
    "mix",
    "sex",
    "oax",
    "pyx",
    "yam",
    "yap",
    "yaw",
    "yay",
    "yeh",
    "yen",
    "yes",
    "yet",
    "yew",
    "yin",
    "yip",
    "you",
    "yum",
    "bay",
    "boy",
    "day",
    "fly",
    "gay",
    "joy",
    "key",
    "lay",
    "may",
    "pay",
    "say",
    "soy",
    "way",
    "why",
    "aye",
    "bye",
    "zag",
    "zap",
    "zed",
    "zen",
    "zig",
    "zin",
    "zip",
    "zit",
    "zoa",
    "biz",
    "fez",
    "lez",
    "viz",
  ];


  const letter3Dictionary = letter3DictionaryArray.map(word => word.toLowerCase());

  export default letter3Dictionary;